import React from "react";
import { FormControl, TextField } from "@material-ui/core";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      "& .MuiInputBase-input": {
        fontSize: "1.4rem",
      },
      "& .MuiInputLabel-outlined": {
        transform: "translate(14px, 18px) scale(1)",
      },
      "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
        transform: "translate(14px, -6px) scale(0.75)",
      },
      "& .MuiInputBase-root": {
        fontSize: "1.4rem",
        innerHeight: "inherit",
      },
      "& .MuiInputLabel-root": {
        textAlign: "center",
        fontSize: "1.4rem",
      },
      "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
        fontSize: "1.4rem",
      },
      "& .MuiFormHelperText-root": {
        fontSize: "1.2rem",
      },
    },
  })
);

type SelectFieldTypes = {
  label: string | any;
  name: string;
  value?: string | number;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: () => void;
  variant?: "outlined" | "filled" | "standard";
  id?: string;
  error?: any;
  helperText?: string | false | undefined;
  fullWidth?: boolean;
  required?: boolean;
  type?: string | undefined;
  textTransform?: "uppercase" | "lowercase" | "capitalize" | "inherit";
  disabled?: boolean;
};

const Multiline = ({
  value,
  onChange,
  onBlur,
  variant = "standard",
  id,
  label,
  error,
  helperText,
  name,
  fullWidth = false,
  required = false,
  disabled,
  type = "text",
  textTransform = "capitalize",
  ...rest
}: SelectFieldTypes) => {
  const classes = useStyles();

  return (
    <FormControl variant={variant} fullWidth={fullWidth}>
      <TextField
        type={type}
        inputRef={(input) => input && input.focus()}
        multiline
        rows={4}
        className={classes.root}
        id={id}
        name={name}
        label={label}
        value={value}
        error={error}
        autoComplete="off"
        helperText={helperText}
        onChange={onChange}
        onBlur={onBlur}
        variant={variant}
        required={required}
        inputProps={{
          autoComplete: "off",
          form: {
            autoComplete: "off",
          },
        }}
        disabled={disabled}
      />
    </FormControl>
  );
};

export default Multiline;
